exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dimension-basicbar-popover{padding:0;border:none;background:transparent}", ""]);

// exports
